import { render, staticRenderFns } from "./MenuDentist.vue?vue&type=template&id=2f45e837&"
import script from "./MenuDentist.vue?vue&type=script&lang=js&"
export * from "./MenuDentist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports